import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Step } from '../stepper/step';
import {
	IInitializePasswordRequest,
	InitializePasswordRequest,
	InitializePassword,
} from '../../classes/initialize-password';
import { StepsService } from '../../services/steps.service';
import { ICodeService } from '../../services/icode.service';
import { PasswordValidator } from '../../../globals/classes/password-validator';
import { UserData, IUserData } from '../../../globals/classes/userData';
import { GoogleAnalyticsUtils } from '../../classes/static/google-analytics-utils';
import { ComponentWithErrors } from '../../classes/component-with-errors';
import { IUserIDRequest } from '../../classes/http-requests';
import { ISendSmsOtpResponse } from '../../classes/http-responses';
import { AppSettings } from '../../app.settings';
import { CreatePasswordIntroModalComponent } from '../create-password-intro-modal/create-password-intro-modal.component';
import {
	ICreateApplicationRequest,
	IResetCredentialsRequest,
	ISendCodeRequest,
	IVerifyCodeRequest,
	IAcceptIbankTermsRequest,
} from '../../classes/existing-onboarding-customer/requests';
import {
	CreateApplicationResponse,
	GetRegisteredMobileNumbersResponse,
	ISendCodeResponse,
	SendCodeResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { ExistingOnboardingVerificationService } from '../../services/existing-recovery/verification.service';
import { VerificationApp } from '../../classes/static/enums';
import { ExistingOnboardingCustomerService } from '../../services/existing-recovery/customer.service';
import { finalize } from 'rxjs/operators/finalize';
import { SourceApis } from '../../../globals/classes/errorDescription';

@Component({
	selector: 'create-password',
	template: require('./create-password.component.html'),
})
export class CreatePasswordComponent extends ComponentWithErrors implements OnInit {
	@Input() public userCode: string;
	@Input() public isNewUser: boolean;

	@Input() public isOnBoardingFlow = false;
	@Input() ibUsernameRequest: string;
	@Input() getRegisteredMobileNumbersResponse: GetRegisteredMobileNumbersResponse;
	@Input() appCreateAppResponse: CreateApplicationResponse;
	@Input() public isExistingCustomer = false;
	@Input() createAppRequest: ICreateApplicationRequest;
	@Input() public isCardModalflow: boolean = false;
	@Input() public isForgetCredentialsRetailModalflow: boolean = false;

	@Input()
	public ibUsernameCheckUsernameAvailabilityResp: string;

	@Input() public hasBackBtn = true;

	public steps: Step[];
	public isValidFrom = false;
	public initRequest: IInitializePasswordRequest = new InitializePasswordRequest();
	public icode: string;
	public isValidPass: boolean;
	public errorMessage: string = null;
	public loading = false;
	public isCustomerOnboardingEnabled: boolean = AppSettings.isCustOnboardingEnabled;
	public hasAcceptTerms: boolean = false;
	public isLoginBigModalEnabled: boolean = AppSettings.isLoginBigModalEnabled;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;
	public isRebrading = AppSettings.isRebrading;

	public sendCodeRequest: ISendCodeRequest;
	public verifyCodeRequest: IVerifyCodeRequest;
	public sendCodeMobileResponse: ISendCodeResponse;
	public acceptIbankTermsRequest: IAcceptIbankTermsRequest;
	public resetCredentialsRequest: IResetCredentialsRequest;

	private userData: IUserData = new UserData();
	startEnterOtpVal: any;

	constructor(
		public stepsService: StepsService,
		private activeModal: NgbActiveModal,
		private icodeService: ICodeService,
		private modalService: NgbModal
	) {
		super();
	}

	public ngOnInit() {
		GoogleAnalyticsUtils.sendCreatePasswordStep1();
		this.steps = this.stepsService.getTransactionSteps('CreatePasswordComponent');
		this.stepsService.setStep(this.steps, 0);
		this.initSubscriptions();
		Object.assign(this.initRequest, { userID: this.userCode });
		PasswordValidator.resetValidation();
		this.initRequests();
	}

	public get hasBack() {
		if (!this.hasBackBtn) {
			return this.stepsService.getCurrentStep != 0;
		} else {
			return true;
		}
	}

	public get isFirstStep(): boolean {
		var createPasswordFlow =
			this.stepsService.getCurrentStep === 0 || this.stepsService.getCurrentStep === 2;
		var onboardingFlow = this.stepsService.getCurrentStep === 2;
		return this.isCustomerOnboardingEnabled ? onboardingFlow : createPasswordFlow;
	}

	public get canGoNext(): boolean {
		if (this.isOnBoardingFlow) return this.canProceedOnBoardingEnable;
		else return this.canProceed;
	}

	public get canProceed(): boolean {
		switch (this.stepsService.getCurrentStep) {
			case 0:
				return this.isValidForm;
			case 1:
				return this.isValidICode;
			default:
				return false;
		}
	}
	public get canProceedOnBoardingEnable(): boolean {
		switch (this.stepsService.getCurrentStep) {
			case 0:
				return this.isValidUserRecoveryForm && this.hasAcceptTerms;
			case 1:
				return this.isValidICode;
			default:
				return false;
		}
	}

	public chooseTitle(): string {
		if (this.isOnBoardingFlow) {
			return 'Δημιουργία password';
		} else {
			return 'Δημιουργία Password';
		}
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public updateTermsValue(value: boolean): void {
		this.hasAcceptTerms = value;
	}
	public next(): void {
		if (this.isOnBoardingFlow) this.proceedExistingOnboarding();
		else this.proceed();
	}

	public proceed(): void {
		if (!this.canProceed) return;
		if (this.stepsService.getCurrentStep === 0) {
			this.sendInitPass();
		} else if (this.stepsService.getCurrentStep === 1) {
			this.initializePassword();
		} else {
			this.handleError();
		}
	}

	public moveBack(steps: Step[]): void {
		if (this.isOnBoardingFlow && this.stepsService.getCurrentStep === 0) {
			this.goBackToCreatePasswordIntro();
		} else if (this.stepsService.getCurrentStep > 0) {
			this.stepsService.moveBackStep(steps);
		}
	}

	public proceedExistingOnboarding(): void {
		if (this.stepsService.getCurrentStep === 0) {
			if (this.dynatraceForExistingOnBoarding) this._setCreateNewPassDynatraceEvent();
			this.invokeSendCode();
		} else if (this.stepsService.getCurrentStep === 1) {
			if (this.dynatraceForExistingOnBoarding)
				this.leaveDynatraceEvent(this.startEnterOtpVal);
			if (this.isExistingCustomer == true) {
				this.invokeResetCredentials();
			} else {
				this.invokeAcceptAllTerms();
			}
		} else {
			this.handleError();
		}
	}

	public initializePassword() {
		this.loading = true;
		Object.assign(this.initRequest, { otp: this.icode });
		this.errorMessage = null;
		InitializePassword.initializePassword(this.initRequest)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(res) => {
					if (res && res.succeeded) {
						this.stepsService.moveNextStep(this.steps);
						GoogleAnalyticsUtils.sendCreatePasswordStep3();
					} else {
						this.handleError();
					}
				},
				(error) => this.handleError(error)
			);
	}

	public sendInitPass(moveNextStep = true) {
		this.loading = true;
		this.errorMessage = null;
		let request: IUserIDRequest = { UserID: this.initRequest.userID };
		InitializePassword.SendInitOtpPass(request)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(res) => {
					if (res && res.succeeded === true) {
						this.resolveSendInitPassResponse(request, res, moveNextStep);
					} else {
						this.handleError();
					}
				},
				(error) => {
					this.handleError(error);
				}
			);
	}

	private chooseSendCodeRequestId(): string {
		if (this.isExistingCustomer == true) {
			if (!this.createAppRequest.appId) return;
			return this.createAppRequest.appId;
		} else {
			if (!this.appCreateAppResponse.appInfo.appId) return;
			return this.appCreateAppResponse.appInfo.appId;
		}
	}

	private chooseSendCodeRequestApplication(): string {
		if (this.isExistingCustomer == true) {
			if (!this.createAppRequest.appId) return;
			return VerificationApp.ibankCredentialsReset;
		} else {
			if (!this.appCreateAppResponse.appInfo.appId) return;
			return VerificationApp.ibankTermsAcceptance;
		}
	}

	private invokeSendCode(moveNextStep = true): void {
		const sendcodereq: ISendCodeRequest = {
			appId: this.chooseSendCodeRequestId(),
			verificationTarget: {
				value: this.getRegisteredMobileNumbersResponse.mobileNumber,
				type: 'sms',
			},
			application: this.chooseSendCodeRequestApplication(),
		};
		this.loading = true;
		ExistingOnboardingVerificationService.sendCode(sendcodereq)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(result) => this.handleSendCodeResponse(result, moveNextStep),
				(error) => this.handleApiError(error, SourceApis.Onboarding)
			);
	}
	private handleSendCodeResponse(response: ISendCodeResponse, moveNextStep = true) {
		if (!!response) {
			let expirationMinutes = Math.abs(
				new Date(response.verificationResult.expiresOn).valueOf() -
					new Date(Date.now()).valueOf()
			);
			let codeLifetimeInSeconds = Math.round(expirationMinutes / 1000);
			setTimeout(() => this.icodeService.resetTimer(codeLifetimeInSeconds), 500);

			Object.assign(this.userData, {
				userId: this.ibUsernameRequest,
				hasSMSOtp: true,
			});

			UserData.update(this.userData);

			this.sendCodeMobileResponse = new SendCodeResponse(response);
			moveNextStep && this.stepsService.moveNextStep(this.steps);
			if (this.dynatraceForExistingOnBoarding) this._setEnterOtpDynatraceEvent();
		}
	}
	private invokeResetCredentials(): void {
		const resetCredentialsReq = {
			appId: this.sendCodeMobileResponse.appId,
			verificationId: this.sendCodeMobileResponse.verificationResult.verificationId,
			verificationCode: this.icode,
			ibUsername: this.ibUsernameCheckUsernameAvailabilityResp,
			passwordDetails: {
				password: this.initRequest.passwordNew,
				passwordConfirm: this.initRequest.passwordConfirmNew,
			},
		};
		this.loading = true;
		ExistingOnboardingCustomerService.resetCredentials(resetCredentialsReq)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(result) => this.handleResetCredentialsResponse(result),
				(error) => {
					if (this.dynatraceForExistingOnBoarding)
						this._setUnsuccesfulRegisDynatraceEvent();
					this.handleApiError(error, SourceApis.Onboarding);
				}
			);
	}
	private handleResetCredentialsResponse(response: boolean) {
		if (!!response && response == true) {
			this.stepsService.moveNextStep(this.steps);
			if (this.dynatraceForExistingOnBoarding) this._setCompleteDynatraceEvent();
		} else return;
	}

	private invokeAcceptAllTerms(): void {
		const acceptIbankTermsReq = {
			appId: this.sendCodeMobileResponse.appId,
			verificationId: this.sendCodeMobileResponse.verificationResult.verificationId,
			verificationCode: this.icode,
			ibUsername: this.ibUsernameRequest,
			passwordDetails: {
				password: this.initRequest.passwordNew,
				passwordConfirm: this.initRequest.passwordConfirmNew,
			},
		};
		this.loading = true;
		ExistingOnboardingCustomerService.acceptIbankTerms(acceptIbankTermsReq)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(result) => this.handleAcceptAllTermsResponse(result),
				(error) => {
					if (this.dynatraceForExistingOnBoarding)
						this._setUnsuccesfulRegisDynatraceEvent();
					this.handleApiError(error, SourceApis.Onboarding);
				}
			);
	}
	private handleAcceptAllTermsResponse(response: boolean) {
		if (!!response && response == true) {
			this.stepsService.moveNextStep(this.steps);
			if (this.dynatraceForExistingOnBoarding) this._setCompleteDynatraceEvent();
		} else return;
	}

	private goBackToCreatePasswordIntro() {
		this.closeModal();
		const modalRef = this.modalService.open(CreatePasswordIntroModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as CreatePasswordIntroModalComponent).ibUsernameRequest =
			this.ibUsernameRequest;
		(modalRef.componentInstance as CreatePasswordIntroModalComponent).appCreateAppResponse =
			this.appCreateAppResponse;
		(
			modalRef.componentInstance as CreatePasswordIntroModalComponent
		).getRegisteredMobileNumbersResponse = this.getRegisteredMobileNumbersResponse;
		(modalRef.componentInstance as CreatePasswordIntroModalComponent).isExistingCustomer =
			this.isExistingCustomer;
		(modalRef.componentInstance as CreatePasswordIntroModalComponent).createAppRequest =
			this.createAppRequest;
		(modalRef.componentInstance as CreatePasswordIntroModalComponent).isCardModalflow =
			this.isCardModalflow;
		(
			modalRef.componentInstance as CreatePasswordIntroModalComponent
		).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	private resolveSendInitPassResponse(
		request: IUserIDRequest,
		res: ISendSmsOtpResponse,
		moveNextStep = true
	) {
		this.icodeService.resetTimer();
		Object.assign(this.userData, {
			userId: request.UserID,
			hasSMSOtp: res.hasOtp,
			maskedPhoneNumber: res.maskedPhoneNumber,
		});

		UserData.update(this.userData);
		moveNextStep && this.stepsService.moveNextStep(this.steps);
		GoogleAnalyticsUtils.sendCreatePasswordStep2();
	}

	private initSubscriptions() {
		this.mortalize(this.icodeService.code$).subscribe((c) => (this.icode = c));
		this.mortalize(this.icodeService.codeRequested$).subscribe(() => this.codeRequested());
		this.mortalize(PasswordValidator.isValidPassAndConfirm$).subscribe(
			(val) => (this.isValidPass = val)
		);
	}

	private codeRequested(): void {
		if (this.isOnBoardingFlow) {
			this.invokeSendCode(false);
		} else {
			this.sendInitPass(false);
		}
	}

	private initRequests() {
		this.resetCredentialsRequest = {
			appId: '',
			verificationId: '',
			verificationCode: '',
			ibUsername: this.ibUsernameCheckUsernameAvailabilityResp,
			passwordDetails: {
				password: this.initRequest.passwordNew,
				passwordConfirm: this.initRequest.passwordConfirmNew,
			},
		};
	}

	private get isValidICode(): boolean {
		return this.icodeService.isValidCode(this.icode);
	}

	private get isValidForm(): boolean {
		return this.initRequest.userID != null && this.isValidPass;
	}
	private get isValidUserRecoveryForm(): boolean {
		return this.ibUsernameRequest != null && this.isValidPass;
	}

	private _setCreateNewPassDynatraceEvent() {
		this.setDynatraceEvent('ECO_Create_Password');
	}

	private _setEnterOtpDynatraceEvent() {
		this.startEnterOtpVal = this.enterDynatraceEvent('ECO_Confirm_IBank_Creds_OTP');
	}

	private _setCompleteDynatraceEvent() {
		this.setDynatraceEvent('ECO_Register_Successfully');
	}

	private _setUnsuccesfulRegisDynatraceEvent() {
		this.setDynatraceEvent('ECO_Register_Unsuccessfully');
	}
}
